import { HALF_DAY_HOURS, lastMinute } from './TimePickerHelper';
/**
 * get range from current hour
 */
export function getNumberPickerBoundary(currentHour, _a) {
    var range = _a.range, isTwelveHourSystem = _a.isTwelveHourSystem;
    var _b, _c, _d, _e;
    var currentIsPM = currentHour >= HALF_DAY_HOURS;
    var maxHour = (_b = range.max.hour) !== null && _b !== void 0 ? _b : 23;
    var maxMinute = (_c = range.max.minute) !== null && _c !== void 0 ? _c : lastMinute;
    var minHour = (_d = range.min.hour) !== null && _d !== void 0 ? _d : 0;
    var minMinute = (_e = range.min.minute) !== null && _e !== void 0 ? _e : 0;
    if (isTwelveHourSystem) {
        if (currentIsPM) {
            if (minHour < HALF_DAY_HOURS) {
                minHour = 0;
                minMinute = 0;
            }
        }
        else if (maxHour >= HALF_DAY_HOURS) {
            maxHour = 11;
            maxMinute = lastMinute;
        }
    }
    if (maxMinute !== lastMinute && currentHour < maxHour) {
        maxMinute = lastMinute;
    }
    if (minMinute !== 0 && currentHour > minHour) {
        minMinute = 0;
    }
    if (isTwelveHourSystem) {
        maxHour = maxHour % HALF_DAY_HOURS;
        minHour = minHour % HALF_DAY_HOURS;
    }
    return {
        hour: {
            min: minHour,
            max: maxHour,
        },
        minute: {
            min: minMinute,
            max: maxMinute,
        },
    };
}
